'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _consts = require('../fetchHelper/consts');

var _consts2 = _interopRequireDefault(_consts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function request(FetchRequest, HttpMethod, url, params, options) {
  var defaultOptions = {
    mode: 'cors',
    credentials: 'include',
    headers: {
      'x-requested-with': 'XMLHttpRequest'
    }
  };

  if (params) {
    defaultOptions.body = _extends({}, params);
  }

  var requestOptions = Object.assign({}, defaultOptions, options);
  requestOptions.headers = Object.assign({}, defaultOptions.headers, options.headers);
  var contentType = requestOptions.headers['Content-Type'];

  if (contentType && contentType === 'application/json' && requestOptions.body) {
    requestOptions.body = JSON.stringify(requestOptions.body);
  }

  return FetchRequest[HttpMethod](url, requestOptions);
}

var headers = {
  'Content-Type': 'application/json'
};

exports.default = function (FetchRequest) {
  return {
    get: function get(url) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return request(FetchRequest, _consts2.default.HttpMethods.GET, url, params, options);
    },
    delete: function _delete(url) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return request(FetchRequest, _consts2.default.HttpMethods.DELETE, url, params, options);
    },
    post: function post(url) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return request(FetchRequest, _consts2.default.HttpMethods.POST, url, params, Object.assign({ headers: headers }, options));
    },
    put: function put(url) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return request(FetchRequest, _consts2.default.HttpMethods.PUT, url, params, Object.assign({ headers: headers }, options));
    },
    patch: function patch(url) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return request(FetchRequest, _consts2.default.HttpMethods.PATCH, url, params, Object.assign({ headers: headers }, options));
    },
    head: function head(url) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return request(FetchRequest, _consts2.default.HttpMethods.HEAD, url, params, Object.assign({ headers: headers }, options));
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/kryfe-lib/es/utils/createAPI.js
// module id = 5g9B
// module chunks = 4